"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_tabs_1 = require("react-tabs");
var React = require("react");
var utils_1 = require("../../../utils");
var urls_1 = require("../../../urls");
var App_1 = require("../../../App");
var contexts_1 = require("../../../interfaces/contexts");
var riskList_1 = require("../riskList");
var causalityList_1 = require("./causalityList");
var riskTargetsContext_1 = require("../../../context/admin/riskTargetsContext");
var TabIndexes = (function () {
    function TabIndexes() {
    }
    TabIndexes.RISKS = 0;
    TabIndexes.CAUSES = 1;
    TabIndexes.EFFECTS = 2;
    return TabIndexes;
}());
var RiskCausalityList = (function (_super) {
    __extends(RiskCausalityList, _super);
    function RiskCausalityList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            tabIndex: TabIndexes.RISKS
        };
        _this.setTabIndex = function (tabIndex) {
            _this.setState({ tabIndex: tabIndex });
        };
        _this.clickRisksHandler = function (event) {
            (0, utils_1.preventDefault)(event);
            history.pushState(null, null, _this.getUrl(urls_1.Urls.risk_list));
        };
        _this.clickCausesHandler = function (event) {
            (0, utils_1.preventDefault)(event);
            history.pushState(null, null, _this.getUrl(urls_1.Urls.cause_list));
        };
        _this.clickEffectsHandler = function (event) {
            (0, utils_1.preventDefault)(event);
            history.pushState(null, null, _this.getUrl(urls_1.Urls.effect_list));
        };
        _this.getUrl = function (url, search) {
            if (search === void 0) { search = true; }
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                var project_id = context.project;
                var location_1 = window.location.search;
                var params = new URLSearchParams(location_1);
                return (0, urls_1.resolve)(url, project_id) + (search ? ("?" + params.toString()) : "");
            }
            else {
                throw new Error("RiskCausalityList does not support the current context");
            }
        };
        _this.whichPanel = function () {
            var risks_url = _this.getUrl(urls_1.Urls.risk_list, false);
            var causes_url = _this.getUrl(urls_1.Urls.cause_list, false);
            var effects_url = _this.getUrl(urls_1.Urls.effect_list, false);
            switch (window.location.pathname) {
                case risks_url:
                    return TabIndexes.RISKS;
                case causes_url:
                    return TabIndexes.CAUSES;
                case effects_url:
                    return TabIndexes.EFFECTS;
                default:
                    return TabIndexes.RISKS;
            }
        };
        _this.getVisibleTabs = function () {
            var items = menu_items || [];
            var showAll = items.length === 0;
            var tabs = [];
            if (showAll || items.includes("risks_list")) {
                tabs.push({ key: "risks", index: TabIndexes.RISKS, label: get_term("Risks"), url: urls_1.Urls.risk_list, onClick: _this.clickRisksHandler });
            }
            if (showAll || items.includes("risks_causes_list")) {
                tabs.push({ key: "causes", index: TabIndexes.CAUSES, label: get_term("Causes"), url: urls_1.Urls.cause_list, onClick: _this.clickCausesHandler });
            }
            if (showAll || items.includes("risks_effects_list")) {
                tabs.push({ key: "effects", index: TabIndexes.EFFECTS, label: get_term("Effects"), url: urls_1.Urls.effect_list, onClick: _this.clickEffectsHandler });
            }
            return tabs;
        };
        return _this;
    }
    RiskCausalityList.prototype.componentDidMount = function () {
        this.setTabIndex(this.whichPanel());
        this.context.fetchRiskColorChoices();
        this.context.fetchOppColorChoices();
    };
    RiskCausalityList.prototype.render = function () {
        var _this = this;
        var visibleTabs = this.getVisibleTabs();
        if (visibleTabs.length === 0) {
            return (React.createElement("div", { className: "alert alert-info" }, gettext("No tabs are enabled for this page.")));
        }
        var selectedIndex = visibleTabs.findIndex(function (t) { return t.index === _this.state.tabIndex; });
        return (React.createElement(react_tabs_1.Tabs, { selectedTabClassName: "active", selectedIndex: selectedIndex >= 0 ? selectedIndex : 0, onSelect: function (index) { var _a, _b; return _this.setTabIndex((_b = (_a = visibleTabs[index]) === null || _a === void 0 ? void 0 : _a.index) !== null && _b !== void 0 ? _b : TabIndexes.RISKS); } },
            React.createElement(react_tabs_1.TabList, { className: "nav nav-tabs risk_list_tabs" }, visibleTabs.map(function (tab) { return (React.createElement(react_tabs_1.Tab, { key: tab.key, className: "nav-item" },
                React.createElement("a", { className: "nav-link", onClick: tab.onClick, href: _this.getUrl(tab.url) }, tab.label))); })),
            visibleTabs.map(function (tab) { return (React.createElement(react_tabs_1.TabPanel, { key: tab.key },
                tab.index === TabIndexes.RISKS && React.createElement(riskList_1.default, null),
                tab.index === TabIndexes.CAUSES && React.createElement(causalityList_1.default, { is_cause: true }),
                tab.index === TabIndexes.EFFECTS && React.createElement(causalityList_1.default, { is_cause: false }))); })));
    };
    RiskCausalityList.contextType = riskTargetsContext_1.default;
    return RiskCausalityList;
}(React.Component));
exports.default = RiskCausalityList;
